import React from 'react';

import SharedAppBar, { makeLogoStyles, makeNavStyles, makeNavDrawerStyles } from '../components/SharedAppBar';


const useLogoStyles = makeLogoStyles( theme => ({
  // layout specific styles here
}));

const useNavStyles = makeNavStyles( theme => ({
  // layout specific styles here
}), { name: 'NavStyles' } );

const useNavDrawerStyles = makeNavDrawerStyles( theme => ({
  // layout specific styles here
}));


export default function AppBar() {
  const logoClasses = useLogoStyles();
  const navClasses = useNavStyles();
  const navDrawerClasses = useNavDrawerStyles();

  return <SharedAppBar {...{navClasses, navDrawerClasses, logoClasses}} />;
}

AppBar.propTypes = {
};
